import { render } from "./Atendimento2.vue?vue&type=template&id=4adff47c&scoped=true"
import script from "./Atendimento2.vue?vue&type=script&lang=js"
export * from "./Atendimento2.vue?vue&type=script&lang=js"

import "./Atendimento2.vue?vue&type=style&index=0&id=4adff47c&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/landing-page-telemedicina /node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adff47c"]])

export default __exports__